/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowDUturnRightUpIcon20Regular = forwardRef('ArrowDUturnRightUpIcon20Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M19.821 7.514a.75.75 0 0 1-1.143.972L15.75 5.04V11a6.75 6.75 0 0 1-13.5 0V6.75a.75.75 0 1 1 1.5 0V11a5.25 5.25 0 1 0 10.5 0V5.04l-2.929 3.445a.75.75 0 0 1-1.143-.972l3.298-3.88a2 2 0 0 1 3.048 0l3.297 3.88Z" })));
});
